
/**
 * Utilitários de Formatação (Migrado para TypeScript)
 */

export function formatMoney(value: number | string | null | undefined): string {
    if (value === undefined || value === null) return 'R$ 0,00';

    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num)) return 'R$ 0,00';

    return num.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
}

// Global exposure for legacy JS (Mantém compatibilidade)
if (typeof window !== 'undefined') {
    window.FazendaRP = window.FazendaRP || {};
    window.FazendaRP.Utils = window.FazendaRP.Utils || {};
    window.FazendaRP.Utils.formatMoney = formatMoney;
}
